<script setup lang="ts">
defineProps<{
  label: string
  help?: string
  labelFor?: string
}>()
</script>

<template>
  <div class="flex min-h-9 items-center justify-between gap-4">
    <slot name="leading" />
    <span class="flex min-w-0 flex-1 flex-col gap-0.5">
      <label :for="labelFor" class="text-sm leading-snug font-medium">{{ label }}</label>
      <slot name="help">
        <span v-if="help" class="text-muted-foreground text-xs leading-snug">{{ help }}</span>
      </slot>
    </span>
    <span class="flex shrink-0 items-center gap-2">
      <slot />
    </span>
  </div>
</template>
